import PanelRight from "src/Component/PanelRight";
import Config from "src/Constants/Config";
import setCurrentPage from "src/Utils/setCurrentPage";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import store from "src/Reducers/store";
import Screen8 from "./Screen8";
import FrameTV from "src/Component/FrameTV";
import BottomTV from "src/Component/BottomTV";

const PageId = 8;
const BackPageId = PageId - 1;
const NextPageId = PageId + 1;

const DATA = () => {
  const baseImageBG = `${Config.BASE_URL}/images/BG/`;
  const baseImages = `${Config.BASE_URL}/images/screen_${PageId}/`;

  const currentPage = useSelector(() => store.getState().appReducer.currentPage);

  const [step, setStep] = useState<number>(0);

  useEffect(() => {
    if (PageId === currentPage) setStep(1);
    else setTimeout(() => setStep(0), 100);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage]);

  const title = "Empower Your Users to Shop\nInstantly";

  const description =
    "With Infosys Entertainment Platform, users can\npurchase exclusive bundles, content, or\nmerchandise directly from their screens. Whether\nit’s the latest Disney+ subscription bundle or\nexclusive movie merchandise, shopping becomes\nas effortless as streaming.\n\n<b>Experience the Power of Integration</b>\n\n•	Select promotions personalized to the viewer’s\npreferences.\n\n•	Use your PIN for secure purchases and activate\nyour OTT products via QR code for effortless\nactivation\n\n•	Instantly unlock or access purchased content—no\nneed to leave the app.";

  const bundles = [
    { id: 1, image: `${baseImages}promotional-tile-0.jpg`, categories: "" },
    { id: 3, image: `${baseImages}promotional-tile-2.jpg`, categories: "" },
    { id: 2, image: `${baseImages}promotional-tile-1.jpg`, categories: "", pulse: true, activeBorder: true },
    { id: 4, image: `${baseImages}promotional-tile-3.jpg`, categories: "" },
    { id: 4, image: `${baseImages}promotional-tile-4.jpg`, categories: "" },
  ];

  const bundlesPkg = [
    { id: 1, image: `${baseImages}small-promotional-tile-0.jpg`, categories: "" },
    { id: 2, image: `${baseImages}small-promotional-tile-1.jpg`, categories: "" },
    { id: 3, image: `${baseImages}small-promotional-tile-2.jpg`, categories: "" },
    { id: 4, image: `${baseImages}small-promotional-tile-3.jpg`, categories: "" },
    { id: 5, image: `${baseImages}small-promotional-tile-4.jpg`, categories: "" },
  ];

  return {
    bgImage: `${baseImageBG}BG_2.jpg`,
    title,
    description,
    rightSideComponent: (
      <PanelRight>
        <FrameTV scrollDisabled={true} scrollTop={step >= 3}>
          <Screen8 step={step} setStep={setStep} pageId={PageId} bundles={bundles} bundlesPkg={bundlesPkg} />
        </FrameTV>
        <BottomTV showSkips={step < 6} backPageId={BackPageId} nextPageId={NextPageId} />
      </PanelRight>
    ),
    back: {
      label: "Back",
      type: "back",
      startIcon: { icon: "arrow-right", color: "#fff" },
      onClick: () => setCurrentPage(BackPageId),
      style: {
        gap: "var(--width-16)",
        opacity: step >= 8 ? 1 : 0,
        transition: step !== 0 ? "opacity 0.5s ease" : "",
        zIndex: step >= 8 ? 1 : -1,
      },
    },
    next: {
      label: "Continue",
      type: "next",
      endIcon: { icon: "arrow-left" },
      onClick: () => setCurrentPage(NextPageId),
      style: {
        gap: "var(--width-16)",
        opacity: step >= 8 ? 1 : 0,
        transition: step !== 0 ? "opacity 0.5s ease" : "",
        zIndex: step >= 8 ? 1 : -1,
      },
    },
  };
};

export default DATA;
